import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BlockAlignmentMiddleIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BlockAlignmentMiddle",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M14.01 2H18c2.12 0 3.84 1.72 3.84 3.84v20.32c0 2.12-1.72 3.84-3.84 3.84h-3.99c-2.12 0-3.84-1.72-3.84-3.84V5.84c0-2.12 1.72-3.84 3.84-3.84M30 16.02v.09c0 .62-.5 1.12-1.12 1.12h-3.59c-.62 0-1.12-.5-1.12-1.12v-.09c0-.62.5-1.12 1.12-1.12h3.59c.62 0 1.12.5 1.12 1.12m-28 .06v-.09c0-.62.5-1.12 1.12-1.12h3.59c.62 0 1.12.5 1.12 1.12v.09c0 .62-.5 1.12-1.12 1.12H3.12C2.5 17.2 2 16.7 2 16.08"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.01 17H5c-.55 0-1-.45-1-1s.45-1 1-1h22.01c.55 0 1 .45 1 1s-.45 1-1 1M20.01 13c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v5c0 .55-.45 1-1 1s-1-.45-1-1V7c0-1.65 1.35-3 3-3h4c1.65 0 3 1.35 3 3v5c0 .55-.45 1-1 1M18.01 28h-4c-1.65 0-3-1.35-3-3v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 1.65-1.35 3-3 3"
      })
    })
  }));
};